import { Table, Typography, Space, Tag, Button } from "antd";
import {
  FolderFilled,
  FileExcelFilled,
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import { useMemo } from "react";
import PermissionModal from "../Modal/PermissionModal";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../constant/routes";

const ListView = ({
  selectedFolder,
  folderList,
  onFolderSelect,
  files,
  user_id,
  setSelectedRecord,
}) => {
  const navigate = useNavigate();
  const tableData = useMemo(
    () => [
      ...(folderList.length && !selectedFolder
        ? [
            {
              id: "folders-title",
              section: true,
              title: "Folders",
            },
            ...folderList.map((folder) => ({
              ...folder,
              itemType: "folder",
            })),
          ]
        : []),
      ...(files.length
        ? [
            {
              id: "files-title",
              section: true,
              title: "Workbooks",
            },
            ...files,
          ]
        : []),
    ],
    [files, selectedFolder, folderList],
  );

  const columns = useMemo(
    () => [
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        render: (_, record) => {
          if (record.section)
            return (
              <Typography.Text strong type="secondary">
                {record.title}
              </Typography.Text>
            );
          return (
            <Space>
              {record.itemType === "folder" ? (
                <FolderFilled
                  style={{
                    color: "#FAAD14",
                    fontSize: 18,
                  }}
                />
              ) : (
                <FileExcelFilled
                  style={{
                    color: "#52C41A",
                    fontSize: 18,
                  }}
                />
              )}
              <span>{record.name}</span>
            </Space>
          );
        },
      },

      {
        title: "Items",
        key: "id",
        width: 140,
        render: (_, record) => {
          if (record.section || !record?.workbooks?.length) return null;

          return <Tag color="blue">{record?.workbooks?.length}</Tag>;
        },
      },
      {
        title: "Created At",
        dataIndex: "created_at",
        key: "created_at",
        width: 220,

        render: (date, record) => {
          if (record.section) return null;
          return dayjs(date).format("DD MMM YYYY, hh:mm A");
        },
      },
      {
        title: "Actions ",
        dataIndex: "action",
        render: (_, record) => {
          if (record.section || user_id !== record?.created_by_user_id)
            return null;
          return (
            <div className="flex icons">
              {record.itemType !== "folder" && (
                <PermissionModal file={record} isList />
              )}
              <Button
                icon={<EditOutlined />}
                type="primary"
                onClick={() =>
                  setSelectedRecord({
                    ...record,
                    isFile: record.itemType !== "folder",
                  })
                }
              />
              <Button
                icon={<DeleteOutlined />}
                danger
                onClick={() =>
                  setSelectedRecord({
                    ...record,
                    isFile: record.itemType !== "folder",
                    isDelete: true,
                  })
                }
              />
            </div>
          );
        },
        onCell: () => ({
          onClick: (e) => e.stopPropagation(),
        }),
      },
    ],
    [user_id],
  );

  return (
    <div>
      <Table
        columns={columns}
        dataSource={tableData}
        pagination={false}
        rowKey="id"
        scroll={{
          y: "calc(100dvh - 160px)",
          x: "max-content",
        }}
        onRow={(record) => {
          return {
            onClick: () => {
              if (record.itemType === "folder") onFolderSelect(record?.id);
              else {
                navigate(`${ROUTES.EXCEL}/${record?.id}`);
              }
            },
          };
        }}
      />
    </div>
  );
};

export default ListView;
